import { render, staticRenderFns } from "./PublicationItem.vue?vue&type=template&id=2147517b&scoped=true&"
import script from "./PublicationItem.vue?vue&type=script&lang=js&"
export * from "./PublicationItem.vue?vue&type=script&lang=js&"
import style0 from "./PublicationItem.vue?vue&type=style&index=0&id=2147517b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2147517b",
  null
  
)

export default component.exports